import { createSelector } from 'reselect';
import type { IUserInfo, IVault } from '../../api/domain';
import type { IRootState } from '../root-reducer';
import { userInfoApiSelectors } from '../user-info-api';

export const getCurrentDocument = (state: IRootState) => state.secureDocumentStoreApi && state.secureDocumentStoreApi.currentDocument;
export const getCurrentDocumentDescription = (state: IRootState) =>
    state.secureDocumentStoreApi && state.secureDocumentStoreApi.currentDocument && state.secureDocumentStoreApi.currentDocument.description;
export const getCurrentDocumentName = (state: IRootState) =>
    state.secureDocumentStoreApi && state.secureDocumentStoreApi.currentDocument && state.secureDocumentStoreApi.currentDocument.name;
export const getDocuments = (state: IRootState) => state.secureDocumentStoreApi && state.secureDocumentStoreApi.documents;
export const getVaults = (state: IRootState) => state.secureDocumentStoreApi && state.secureDocumentStoreApi.vaults;
export const getUnreadDocumentsCount = (state: IRootState) => state.secureDocumentStoreApi && state.secureDocumentStoreApi.unreadDocumentsCount;
export const getTotalDocumentsCount = (state: IRootState) => state.secureDocumentStoreApi && state.secureDocumentStoreApi.totalDocumentsCount;
export const getMediaTypes = (state: IRootState) => state.secureDocumentStoreApi && state.secureDocumentStoreApi.mediaTypes;
export const getSettings = (state: IRootState) => state.secureDocumentStoreApi && state.secureDocumentStoreApi.settings;
export const getTags = (state: IRootState) => state.secureDocumentStoreApi && state.secureDocumentStoreApi.tags;

export const getOrderedVaults: (state: IRootState) => IVault[] = createSelector(
    getVaults,
    userInfoApiSelectors.getUserInfo,
    (vaults: IVault[], userInfo?: IUserInfo) => {
        if (!userInfo) {
            return vaults;
        }

        const ownVaults = vaults.filter((mb) => mb.commonObject.externalIds?.includes(userInfo.userId));
        const otherVaults = vaults.filter((mb) => !mb.commonObject.externalIds?.includes(userInfo.userId));

        return [...ownVaults, ...otherVaults];
    },
);
